/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 18.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import randomstring from "randomstring";

import BaseContainer from "../containers/BaseContainer";
import {SessionStore, SessionActions} from "../services/Session";
import Navigation from "../Navigation";
import {NotificationActions} from "../services/Notification";
import Log from "../Log";
import t from "../trans";

const propTypes = {
    location: PropTypes.shape({
        query: PropTypes.shape({
            /**
             * Authentication token
             */
            code: PropTypes.string,
            /**
             * Random state string
             */
            state: PropTypes.string
        }),
        state: PropTypes.shape({
            /**
             * Where to redirect after login
             */
            redirect: PropTypes.string
        })
    })
};

const defaultProps = {};

/**
 * Login component.
 * If called without parameters redirects to OAuth2 authentication page.
 * If called with URL parameters then implements OAuth2 auth callback interface
 */
class Login extends BaseContainer {
    /**
     * @member {LoginState} this.state
     *
     * @typedef {Object} LoginState
     * @property {SessionState} session
     */

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props, {
            session: SessionStore
        });
    }

    componentDidMount() {
        if (this.props.location != null && this.props.location.query != null && this.props.location.query.code) {
            this.processAuthResponse();
        } else {
            this.makeAuthRedirect();
        }
    }

    /**
     * Redirect to auth service:
     */
    makeAuthRedirect() {
        let nonce = randomstring.generate(32);
        SessionActions.startAuthentication.defer(nonce);
    }

    /**
     * Get access token
     */
    processAuthResponse() {
        let authToken = this.props.location.query.code;
        let authNonce = this.props.location.query.state;

        if (!authToken || this.state.session.nonce !== authNonce) {
            // No auth token or invalid nonce, goto main page.
            SessionActions.sessionExpired.defer();
            Navigation.gotoMain();
        } else {
            // Verify auth token
            SessionActions.login.defer(authToken);
        }
    }

    loadingFinished(key, newState) {
        if (key !== "session") return super.loadingFinished(key, newState);
        let action = newState.action.method;
        switch (action) {
            case "startAuthentication":
                if (!newState.nonce) {
                    Log.error("Internal error: No nonce");
                    NotificationActions.error.defer(t("Internal error: Invalid state"));
                    Navigation.gotoMain();
                }
                Navigation.gotoAuth(newState.nonce, (this.props.location.state ? this.props.location.state.redirect : null) );
                break;
            case "post":
                if (newState.currentRecord && newState.currentRecord.token) {
                    // Authentication successful.
                    if (this.props.location.state && this.props.location.state.redirect) Navigation.push(this.props.location.state.redirect);
                    else Navigation.gotoUi();
                }
                else {
                    NotificationActions.error.defer(t("Invalid response from server: access token not found"));
                    Navigation.gotoMain();
                }
                break;
            default:
                NotificationActions.error.defer(t("Internal error: Invalid state"));
                Navigation.gotoMain();
        }
    }

    loadingFailed(key, newState) {
        NotificationActions.error.defer(newState.error.message);
        Navigation.gotoMain();
    }


    render() {
        return (
            <div/>
        );
    }
}

Login.propTypes = propTypes;
Login.defaultProps = defaultProps;

export default Login;
